import React from 'react';
import { Row, Col } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import {
    TfiDesktop,
    TfiUser,
    TfiDirection,
    TfiPanel,
    TfiLock,
    TfiEye,
    TfiImport,
    TfiCalendar,
    TfiPackage,
    TfiDirectionAlt,
    TfiControlPlay,
    TfiKey,
    TfiSettings,
    TfiStatsUp
} from 'react-icons/tfi';
import emailImage from '../../assets/img/email-full.png';
import vpsImage from '../../assets/img/vps-full.png';
import './emailsWidget.scss';

function EmailsWidget({ dataType }) {
    const { t } = useTranslation();
    const isVps = dataType === 'vps';
    let emailsData = [
        {
            title: t('email-page.emails-column.property-1'),
            image: <TfiImport />
        },
        {
            title: t('email-page.emails-column.property-2'),
            image: <TfiDesktop />
        },
        {
            title: t('email-page.emails-column.property-3'),
            image: <TfiUser />
        },
        {
            title: t('email-page.emails-column.property-4'),
            image: <TfiDirection />
        },
        {
            title: t('email-page.emails-column.property-5'),
            image: <TfiLock />
        },
        {
            title: t('email-page.emails-column.property-6'),
            image: <TfiPanel />
        },
        {
            title: t('email-page.emails-column.property-7'),
            image: <TfiEye />
        },
        {
            title: t('email-page.emails-column.property-8'),
            image: <TfiCalendar />
        }
    ];

    if (isVps) {
        emailsData = [
            {
                title: t('vps-page.vps-column.property-1'),
                image: <TfiPackage />
            },
            {
                title: t('vps-page.vps-column.property-2'),
                image: <TfiDirectionAlt />
            },
            {
                title: t('vps-page.vps-column.property-3'),
                image: <TfiControlPlay />
            },
            {
                title: t('vps-page.vps-column.property-4'),
                image: <TfiDesktop />
            },
            {
                title: t('vps-page.vps-column.property-5'),
                image: <TfiKey />
            },
            {
                title: t('vps-page.vps-column.property-6'),
                image: <TfiSettings />
            },
            {
                title: t('vps-page.vps-column.property-7'),
                image: <TfiImport />
            },
            {
                title: t('vps-page.vps-column.property-8'),
                image: <TfiStatsUp />
            }
        ];
    }
    const renderEmailItem = (email, index) => (
        <Col md={6} key={`${email.title}-${index}`}>
            <div className="single-cpanel">
                <div className="cpanel-image-wrapper">{email.image}</div>
                <h3 className="cpanel-title">{email.title}</h3>
            </div>
        </Col>
    );

    return (
        <div className="cpanel-columns-wrapper">
            <Row>
                <Col lg={6}>
                    <img
                        className="cpanel-main-image"
                        src={isVps ? vpsImage : emailImage}
                        alt={isVps ? 'Vps' : 'Email'}
                    />
                </Col>
                <Col lg={6}>
                    <Row>{emailsData.map(renderEmailItem)}</Row>
                </Col>
            </Row>
        </div>
    );
}

EmailsWidget.propTypes = {
    dataType: PropTypes.string
};

EmailsWidget.defaultProps = {
    dataType: 'email'
};

export default EmailsWidget;
